import api from "./axios";

export async function getDuctAsync(id) {
  const ductsRes = await api.get("/duct");
  const ductList = ductsRes.data || [];

  return ductList.find((d) => String(d.id) === String(id));
}
